"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _TelephoneData = require("I18n/constants/TelephoneData");

var _default = function _default(code) {
  var countries = _TelephoneData.allCountries;
  var countryStringsPath = 'SharedI18nStrings.countryCodes';

  var getCountryName = function getCountryName(countryCode) {
    return _I18n.default.text(countryStringsPath + "." + countryCode.toUpperCase());
  };

  var translatedCountries = _I18n.default.text(countryStringsPath);

  if (translatedCountries[code.toUpperCase()]) {
    return getCountryName(code);
  }

  var countryData = countries.find(function (country) {
    return country.iso2 === code.toLowerCase();
  });

  if (countryData) {
    return countryData.name;
  }

  return _I18n.default.text('i18nAddon.countryInfo.invalidCountryOption');
};

exports.default = _default;
module.exports = exports.default;